module.exports = __webpack_public_path__ + "static/img/about-bg.f61bc3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-2/about-bg.png
// module id = F0os
// module chunks = 36